/*
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */

import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import * as get from 'lodash/get';
import login from 'modules/Auth/actions/login';
import { ssoWindowFeatures, ssoWindowName } from 'const';
import presenter from './presenter';

interface ILoginStateProps {
  backUrl: string;
  message: string;
}

interface ILoginDispatchProps {
  goToSSO: Function;
}

interface ILoginOwnProps {
  forceSSO: boolean;
}

interface ILoginProps extends ILoginStateProps, ILoginDispatchProps, ILoginOwnProps {};

class Login extends Component<ILoginProps, {}> {
  componentWillMount() {
    if (this.props.forceSSO) {
      this.props.goToSSO();
    }
  }

  render() {
    return presenter(this.props);
  }
}

function mapStateToProps(state: Object, ownProps: Object): ILoginStateProps {
  const message = get(state, 'routing.locationBeforeTransitions.query.message', '');

	return <ILoginStateProps> {
		backUrl: get(state, 'auth.core.backUrl', '/'),
    forceSSO: get(ownProps, 'location.query.forceSSO', false),
    message,
	};
}

function handleLoginResult(backUrl, message) {
  if (message.data.type === 'loginResult') {
    // protection from webpack's post message    
    window.location.href = backUrl;
  }
}

const mapDispatchToProps = function(dispatch) {
	return {
    goToSSO: function(backUrl) {
      window.addEventListener('message', handleLoginResult.bind(null, backUrl));
  		window.open('/auth/sso', ssoWindowName, ssoWindowFeatures);
    },
  }
};

function mergeProps(
    stateProps: ILoginStateProps,
    dispatchProps: ILoginDispatchProps,
    ownProps: ILoginOwnProps
  ): ILoginProps {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    goToSSO: () => {
      dispatchProps.goToSSO(stateProps.backUrl);
    },
  };
}

export default connect<ILoginStateProps, ILoginDispatchProps, ILoginOwnProps>(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(Login);
